'use client';

import { YesNoNo } from '@finn/design-system/icons/yes-no-no';
import { useIntl } from '@finn/ui-utils';

import { AppLayout } from '../layouts';

export const generateMetadata = async () => {
  return {
    title: '500',
  };
};

const CustomErrorPage = () => {
  const { formatMessage } = useIntl();

  return (
    <AppLayout>
      <AppLayout.Main>
        <div className="container">
          <div className="my-16 flex flex-col gap-8">
            <div aria-hidden>
              <YesNoNo width={48} height={48} />
            </div>
            <h1 className="mobile-t1-semibold md:web-t1-semibold">
              500 <br /> {formatMessage('error-pages.500.heading')}
            </h1>
            <p className="body-16-regular">
              {formatMessage('error-pages.500.body')}
            </p>
          </div>
        </div>
      </AppLayout.Main>
    </AppLayout>
  );
};

export default CustomErrorPage;
